import { Component, Input, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { ExaminerCalendarControllerService } from '../../services/examiner-calendar-controller.service';
import { CalendarControllerToken } from '../../../calendar/services/interfaces/calendar-controller-service.interface';


@DwComponent({
  key: 'examiner-booking-calendar',
  name: 'Examiner Booking Calendar',
  componentType: DwComponentType.pageComponent,
  isGlobal: true,
})
@Component({
  selector: 'app-examiner-calendar',
  templateUrl: './examiner-calendar.component.html',
  styleUrls: ['./examiner-calendar.component.scss'],
  providers: [
      {
      provide: CalendarControllerToken,
      useClass: ExaminerCalendarControllerService
    }
  ]
})
export class ExaminerCalendarComponent implements OnInit {
  @Input() hideActionBar: boolean = false;
  @Input() compactView: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
